import { doRequest } from '../requests/actions';

export const actions = {
  ADD: 'TEAMS_ADD',
  SET: 'TEAMS_SET',
  REMOVE: 'TEAMS_REMOVE',
  CLEAR: 'TEAMS_CLEAR',
};

export function add(team) {
  return {
    type: actions.ADD,
    value: team,
  };
}

export function set(teams) {
  return {
    type: actions.SET,
    value: teams,
  };
}

export function remove(id) {
  return {
    type: actions.REMOVE,
    value: id,
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}
/**
 * creates a new team at the current location.
 * @param {Object} team to create.
 * @param {String} team.name of team.
 * @param {String} team.color of team.
 * @returns {Promise} returns a promise resolving on team creation.
 */
export function create(team, locationId) {
  return async (dispatch, getState) => {
    const loc = locationId || getState().getIn(['device', 'location', 'id']);
    const { name, colour } = team;

    if (!loc) {
      throw new Error('no locationId is set');
    }
    if (!name) {
      throw new Error('no name is set');
    }
    if (!colour) {
      throw new Error('no colour is set');
    }

    return dispatch(doRequest({
      endpoint: '/departments',
      method: 'POST',
      data: {
        name,
        colour,
        location_id: loc,
      },
    }));
  };
}

export function createMultiple(teams, locationId) {
  return async dispatch =>
    Promise.all(teams.map(async (team) => {
      const t = await dispatch(create(team, locationId));
      dispatch(add(t));
      return t;
    }));
}

/**
 * TODO: error handling
 * Lazily reloads the teams from the server
 * @returns {function(*)}
 */
export function refresh() {
  return async (dispatch) => {
    const teams = await dispatch(doRequest({ endpoint: '/departments' }));
    if (teams) {
      dispatch(set(teams));
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/teams/actions.js